import React, { PropsWithChildren, useState } from 'react'
import { Text, View, Modal, Dimensions, TouchableOpacity, StyleProp, ViewStyle } from 'react-native'
import { useTranslation } from 'react-i18next'
import { styles } from './styles'
import { buttonStyle } from '../../theme/buttons'
import { disabledGray } from '../../theme/colors'

const WIDTH_WINDOW = Dimensions.get('window').width

interface Props extends PropsWithChildren {
  title?: string
  action?: () => void
  cancelButton?: boolean
  actionCancelButton?: () => void
  style?: StyleProp<ViewStyle>
  successLabel?: string
  cancelLabel?: string
}

export const AlertMessage = ({
  title,
  children,
  action,
  cancelButton,
  actionCancelButton,
  style,
  successLabel,
  cancelLabel,
}: Props) => {
  const { t } = useTranslation()

  const width = WIDTH_WINDOW * 0.9

  const [show, setShow] = useState(true)

  return (
    <Modal
      animationType='fade'
      transparent={true}
      visible={show}
      style={[
        {
          marginTop: 10,
        },
        style,
      ]}
      statusBarTranslucent={true}
      onRequestClose={() => {
        setShow(!show)
      }}
    >
      <View style={{ ...styles.centeredView }}>
        <View style={{ ...styles.containerContentModal, width }}>
          {title && <Text style={styles.title}>{t(title)}</Text>}
          <View>{children}</View>

          <View style={{ flexDirection: 'row', justifyContent: 'center', gap: 24 }}>
            {cancelButton && (
              <TouchableOpacity
                activeOpacity={0.8}
                style={[buttonStyle.basic, { backgroundColor: disabledGray }]}
                onPress={() => {
                  setShow(!show)
                  actionCancelButton && actionCancelButton()
                }}
              >
                <Text style={buttonStyle.text}>{t(cancelLabel ?? 'Cancelar')}</Text>
              </TouchableOpacity>
            )}
            <TouchableOpacity
              activeOpacity={0.8}
              style={buttonStyle.basic}
              onPress={() => {
                setShow(!show)
                action && action()
              }}
            >
              <Text style={buttonStyle.text}>{t(successLabel ?? 'Ok')}</Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </Modal>
  )
}
